import { useSiteContent } from '@/context/SiteContentContext';
import { useTheme } from '@/context/ThemeContext';

export default function StatsSection() {
  const { content } = useSiteContent();
  const { stats } = content;
  const { theme } = useTheme();
  const light = theme === 'light';

  return (
    <section className={`w-full py-16 transition-colors duration-300 ${light ? 'bg-gray-900' : 'bg-[#0A0A0A]'}`}>
      <div className="w-full px-6 md:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-0 divide-x divide-white/10">
          {stats.map((s, i) => (
            <div key={i} className="flex flex-col items-center text-center px-8 py-4">
              <p className="text-4xl md:text-5xl font-black mb-1" style={{ color: 'var(--accent)' }}>{s.value}</p>
              <p className="text-white font-bold text-sm tracking-wide mb-1">{s.label}</p>
              <p className="text-white/40 text-xs">{s.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
